import { RedButton } from 'components/Button'
import Column from 'components/Column'
import iconColor from 'components/iconColor'
import InputContainer from 'components/InputContainer'
import FasTimes from 'components/Legacy/Icons/FasTimes'
import Text from 'components/Text'
import { selectors } from 'data'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { useSelector } from 'react-redux'
import { Field } from 'redux-form'
import styled from 'styled-components'
import { px, validator } from 'utils'

import Container from '../Container'
import { StyledInput } from './styles'
import { PropsType as _P } from './template'

const StyledContainer = styled(Container)`
  text-align: left;
`
const Times = styled(FasTimes)`
  ${iconColor('red600')}
`
const Row = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`
const Action = styled(Text)`
  margin-left: 1.5rem;
`

type PropsType = _P & WrappedComponentProps

const Disable = ({ intl, invalid }: PropsType) => {
  const twoFactorStatus = useSelector(selectors.auth.getTwoFactorStatus)

  return (
    <StyledContainer>
      <Column>
        <Text color='white' size='xl' weight={600}>
          {intl.formatMessage(messages.title_disable_whitelisting)}
        </Text>
        <Text color='grey400' style={{ margin: '0.75rem 0 1.5rem' }} weight={500}>
          {intl.formatMessage(messages.sub_title_disable_whitelisting)}
        </Text>
      </Column>
      <Column>
        <InputContainer>
          <Row>
            <Times size={px(1.1)} />
            <Action color='grey400' weight={500}>
              {intl.formatMessage(messages.whitelist_disable_point_one)}
            </Action>
          </Row>
          <Row>
            <Times size={px(1.1)} />
            <Action color='grey400' weight={500}>
              {intl.formatMessage(messages.whitelist_disable_point_two)}
            </Action>
          </Row>
        </InputContainer>
        <InputContainer>
          <Field
            component={StyledInput}
            data-lpignore='true'
            e2e='2faCode'
            label={intl.formatMessage(messages.label_code)}
            name='code'
            placeholder={intl.formatMessage(messages.title_verify_2fa)}
            type={twoFactorStatus!.includes('WALLET_YUBIKEY') ? 'password' : 'text'}
            validate={[validator.required]}
          />
        </InputContainer>

        <RedButton disabled={invalid} e2e='disableButton' type='submit'>
          {intl.formatMessage(messages.whitelist_disable)}
        </RedButton>
      </Column>
    </StyledContainer>
  )
}

export default injectIntl(Disable)
